import { render, staticRenderFns } from "./tiktok.vue?vue&type=template&id=02bea4d0&"
import script from "./tiktok.vue?vue&type=script&lang=js&"
export * from "./tiktok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports